/* eslint-env browser */

'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./shop/shopPage'));
});
